export default __webpack_public_path__ + "static/media/Pretendard-ExtraLight.subset.fb3afdcc.woff";